<div class="supplementary-equipment no-field-space">
  <sc-master-detail [selection]="[selectedEquipment]" [data]="euqipment" [newStyle]="true"
    (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
    (deleteEntry)="onDeleteEntry($event);">

    <sc-scroll-pane>
      <sc-padding>

        <sc-tab-group>
          <sc-tab
            titleDictionaryKey="tmc-yard.supplementaryequipment.ui.base-data">

            <ng-container *ngIf="workingCopyDetails">

              <sc-content-spacer vertical></sc-content-spacer>

              <sc-dictionary-field [model]="workingCopyDetails.name" [defaultLabel]="'name'"
                [labelDictionaryKey]="'tmc-yard.supplementaryequipment.common.name'" [required]="true" [maxlength]="255">
              </sc-dictionary-field>

              <sc-content-spacer vertical></sc-content-spacer>

              <mat-checkbox class="form-checkbox" [(ngModel)]="workingCopyDetails.singleUse">
                <sc-dictionary-label dictionaryKey="tmc.admin.supplementary-equipment.singleUse"></sc-dictionary-label>
              </mat-checkbox>

              <sc-content-spacer vertical></sc-content-spacer>

              <sc-flex>

                <mat-form-field class="parameter-type-field" appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc.admin.supplementary-equipment.singleUse"></sc-dictionary-label>
                  </mat-label>
                  <mat-select [(ngModel)]="workingCopyDetails.parameter1Type">
                    <mat-option *ngFor="let o of parameterTypeOptions" value="{{o.option}}">
                      <sc-dictionary-label dictionaryKey="tmc.admin.supplementary-equipment.parameterType.{{o.name}}"></sc-dictionary-label>
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <sc-content-spacer></sc-content-spacer>

                <sc-dictionary-field [model]="workingCopyDetails.parameter1" [defaultLabel]="'parameter 1 name'"
                  [labelDictionaryKey]="'tmc-yard.supplementaryequipment.ui.parameter1.name'" [required]="false"
                  [maxlength]="255" style="width: 400px;">
                </sc-dictionary-field>

              </sc-flex>

              <sc-content-spacer vertical></sc-content-spacer>

              <sc-flex>

                <mat-form-field class="parameter-type-field" appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc.admin.supplementary-equipment.parameter2.type"></sc-dictionary-label>
                  </mat-label>
                  <mat-select [(ngModel)]="workingCopyDetails.parameter2Type">
                    <mat-option *ngFor="let o of parameterTypeOptions" value="{{o.option}}">
                      <sc-dictionary-label dictionaryKey="tmc.admin.supplementary-equipment.parameterType.{{o.name}}"></sc-dictionary-label>
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <sc-content-spacer></sc-content-spacer>

                <sc-dictionary-field [model]="workingCopyDetails.parameter2" [defaultLabel]="'parameter 2 name'"
                  [labelDictionaryKey]="'tmc-yard.supplementaryequipment.ui.parameter2.name'" [required]="false"
                  [maxlength]="255" style="width: 400px;">
                </sc-dictionary-field>

              </sc-flex>

              <sc-content-spacer vertical></sc-content-spacer>

              <sc-flex>

                <mat-form-field class="parameter-type-field" appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc.admin.supplementary-equipment.parameter3.type"></sc-dictionary-label>
                  </mat-label>
                  <mat-select [(ngModel)]="workingCopyDetails.parameter3Type">
                    <mat-option *ngFor="let o of parameterTypeOptions" value="{{o.option}}">
                      <sc-dictionary-label dictionaryKey="tmc.admin.supplementary-equipment.parameterType.{{o.name}}"></sc-dictionary-label>
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <sc-content-spacer></sc-content-spacer>

                <sc-dictionary-field [model]="workingCopyDetails.parameter3" [defaultLabel]="'parameter 3 name'"
                  [labelDictionaryKey]="'tmc-yard.supplementaryequipment.ui.parameter3.name'" [required]="false"
                  [maxlength]="255" style="width: 400px;">
                </sc-dictionary-field>

              </sc-flex>

            </ng-container>

          </sc-tab>
          <sc-tab
            titleDictionaryKey="tmc-yard.supplementaryequipment.ui.identifier">

            <sc-content-spacer vertical></sc-content-spacer>

            <app-equipment-identifier [selectedDetails]="selectedDetails" (deleteClicked)="deleteIdentifier($event)"
              (changeActiveClicked)="changeActiveOfIdentfier($event)"
              (addNewIdentifierClicked)="addNewIdentifier($event)"></app-equipment-identifier>

          </sc-tab>

        </sc-tab-group>

      </sc-padding>
    </sc-scroll-pane>

    <ng-template masterDetailToolbar>
      <div class="spacer grow"></div>
      <sc-cancel-button  type="button" class="config-changed-button" (click)="cancel()"
      [disabled]="cancelDisabled"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button primary type="button" class="config-changed-button" (click)="save()"
      [disabled]="saveDisabled"></sc-save-button>
    </ng-template>

  </sc-master-detail>
</div>
